import React from "react";

const values = [
  {
    img: "https://i.ibb.co/ckxDsvX/handshake.png",
    name: "Fast & Long Lasting partnership",
  },
  {
    img: "https://i.ibb.co/xjCGPJ9/like.png",
    name: "Excellent Service.",
  },
  {
    img: "https://i.ibb.co/Kmz2fDt/settings.png",
    name: "Progressive",
  },
  {
    img: "https://i.ibb.co/VY42HTW/delivery.png",
    name: "Committed to Delivery",
  },
  {
    img: "https://i.ibb.co/j3rK9Df/package.png",
    name: "Quality Products",
  },
  {
    img: "https://i.ibb.co/4P8GdnX/project-management.png",
    name: "Innovative solutions",
  },
];

const HomeCorporationValue = () => {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14" data-aos="fade-up">
          <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
            Core Principles
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
            CORPORATE VALUE
          </h2>
          <p className="text-slate-500 mt-3 text-sm sm:text-base leading-relaxed">
            As a global enterprise, Our corporate values set the foundation <br className="hidden sm:inline" />
            of business methodologies and guide us towards our vision:
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {values.map((v, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl bg-white border border-slate-200/80 shadow-sm hover:shadow-lg hover:border-slate-300 transition-all duration-300 hover:-translate-y-1 flex flex-col items-center text-center justify-center gap-4"
              data-aos="fade-up"
              data-aos-delay={i * 50}
            >
              <div className="w-16 h-16 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center p-3 group-hover:scale-110 transition-transform duration-300">
                <img src={v.img} alt="" className="h-10 w-10 object-contain" />
              </div>
              <p className="font-bold text-slate-800 text-sm sm:text-base leading-snug">
                {v.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeCorporationValue;
